import { Model } from 'modules/core/lib/mobx-rest'

interface IMembership {
  id: number
  company_id: number
  employee_id: number
  team_id: number
  lead: boolean
}

class Membership extends Model<IMembership> {
  static urlRoot() {
    return '/memberships'
  }
}

export default Membership
